export default __webpack_public_path__ + "static/media/relaxing.1ddfb94d.svg";